// Listen out for events pushed from the Pixels sandbox and push them to the main dataLayer
window.addEventListener('message', function(event) {
    let data = event.data;

    // Only try to parse if it's a string and looks like it might be JSON
    if (typeof data === 'string' && (data.startsWith('{') || data.startsWith('['))) {
      try {
        data = JSON.parse(data);
      } catch (error) {
        console.log('Message is not JSON, using as-is');
      }
    }
    
    // Check if it's our pixel data
    if (data && data.type === 'PIXEL_DATA') {
      console.log('Received pixel data:', data.payload);
      processPixelData(data.eventType, data.payload);
    }
  }, false);
  
  function processPixelData(eventType, payload) {
    // Push the data to the main page's dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload); 
    console.log(`Pushed ${eventType} event to dataLayer:`, payload);
    // You can add additional processing here if needed
  }